import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const TabletIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66658 2.5V2.91667C6.66658 3.60702 7.22623 4.16667 7.91658 4.16667H12.0833C12.7736 4.16667 13.3333 3.60702 13.3333 2.91667V2.5H14.9999C15.9204 2.5 16.6666 3.24619 16.6666 4.16667V17.5C16.6666 18.4205 15.9204 19.1667 14.9999 19.1667H4.99992C4.07944 19.1667 3.33325 18.4205 3.33325 17.5V4.16667C3.33325 3.24619 4.07944 2.5 4.99992 2.5H6.66658Z"
        fill="#5AB8F1"
        {...svgAttrs}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.16667 1.66683C9.16667 1.20659 9.53976 0.833496 10 0.833496C10.4602 0.833496 10.8333 1.20659 10.8333 1.66683H12.0833C12.3135 1.66683 12.5 1.85338 12.5 2.0835V2.91683C12.5 3.14695 12.3135 3.3335 12.0833 3.3335H7.91667C7.68655 3.3335 7.5 3.14695 7.5 2.91683V2.0835C7.5 1.85338 7.68655 1.66683 7.91667 1.66683H9.16667Z"
        fill="#5AB8F1"
        {...svgAttrs}
      />
      <path
        opacity="0.3"
        d="M9.16659 8.3335H6.66659C6.20635 8.3335 5.83325 8.70659 5.83325 9.16683C5.83325 9.62707 6.20635 10.0002 6.66659 10.0002H9.16659C9.62682 10.0002 9.99992 9.62707 9.99992 9.16683C9.99992 8.70659 9.62682 8.3335 9.16659 8.3335Z"
        fill="#5AB8F1"
        {...svgAttrs}
      />
      <path
        opacity="0.3"
        d="M12.4999 11.6665H6.66659C6.20635 11.6665 5.83325 12.0396 5.83325 12.4998C5.83325 12.9601 6.20635 13.3332 6.66659 13.3332H12.4999C12.9602 13.3332 13.3333 12.9601 13.3333 12.4998C13.3333 12.0396 12.9602 11.6665 12.4999 11.6665Z"
        fill="#5AB8F1"
        {...svgAttrs}
      />
    </svg>
  );
};

export default TabletIcon;
